import Alert from '@mui/material/Alert';
import { useDispatch } from 'react-redux';
import * as actions from '../../../store/ancillary/actions';
import { NOTIFICATION_TYPES } from '../../../constants/notifications';

const MessageBanner = props => {
	const dispatch = useDispatch();

	let iconChoice = 'info';

	switch (props.type) {
		case NOTIFICATION_TYPES.ERROR:
			iconChoice = 'Error';
			break;
		case NOTIFICATION_TYPES.WARNING:
			iconChoice = 'Warning';
			break;
		case NOTIFICATION_TYPES.INFO:
			iconChoice = 'Info';
			break;
		case NOTIFICATION_TYPES.SUCCESS:
			iconChoice = 'Success';
			break;
		default:
			iconChoice = 'Info';
	}

	return (
		<Alert
			severity={iconChoice.toLowerCase()}
			onClose={() => {
				dispatch(
					actions.clearMessage({
						messageIndex: props.index,
					})
				);
			}}
		>
			{props.text}
		</Alert>
	);
};

export default MessageBanner;
